function scrollToSection(sectionId) {
    const element = document.getElementById(sectionId);
    if (element) {
        element.scrollIntoView({
            behavior: 'smooth'
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    /**
     * Table Of Contents – Core Article Structure Only
     */

    // Generate ID for links
    const generateSectionID = (headingText) => {
        return headingText.toLowerCase().replace(/\s+/g, '-');
    }

    const h2Elements = document.querySelectorAll("#toc-target-content h2");
    const mainArticle = document.querySelector("#toc-target-content");

    const mainArticleVirtual = document.createElement('article');
    mainArticleVirtual.id = 'toc-target-content';

    // Wrap content before the first H2 in a section
    if (mainArticle && mainArticle.firstElementChild && mainArticle.firstElementChild.tagName !== 'H2') {
        let elementsUntilH2 = [];
        let child = mainArticle.firstElementChild;

        while (child && child.tagName !== 'H2') {
            elementsUntilH2.push(child);
            child = child.nextElementSibling;
        }

        const section = document.createElement('section');
        elementsUntilH2.forEach(element => {
            section.appendChild(element);
        });

        if (mainArticle.firstElementChild) {
            mainArticle.insertBefore(section, mainArticle.firstElementChild);
        } else {
            mainArticle.appendChild(section);
        }

        mainArticleVirtual.append(section);
    }

    h2Elements.forEach(h2 => {
        const h2Section = document.createElement('section');
        const h2Id = generateSectionID(h2.textContent);
        h2Section.id = h2Id;

        let nextElement = h2.nextElementSibling;
        h2Section.append(h2.cloneNode(true));

        while (nextElement && nextElement.tagName !== 'H2') {
            if (nextElement.tagName === 'H3') {
                const h3Section = document.createElement('section');
                const h3Id = generateSectionID(nextElement.textContent);
                h3Section.id = h3Id;

                h3Section.append(nextElement.cloneNode(true));

                nextElement = nextElement.nextElementSibling;

                while (nextElement && (nextElement.tagName !== 'H2' && nextElement.tagName !== 'H3')) {
                    h3Section.append(nextElement.cloneNode(true));
                    nextElement = nextElement.nextElementSibling;
                }

                h2Section.append(h3Section.cloneNode(true));
            } else {
                h2Section.append(nextElement.cloneNode(true));
                nextElement = nextElement.nextElementSibling;
            }
        }

        mainArticleVirtual.append(h2Section);
    });

    if (mainArticle && mainArticle.parentNode) {
        mainArticle.parentNode.replaceChild(mainArticleVirtual, mainArticle);
    } else {
        console.error('mainArticle or its parentNode is not found');
    }
});


function animateCounter(element, finalCount, duration) {
    const initialCount = parseInt(element.dataset.animateFrom);

    let startTime = null;

    const step = (timestamp) => {
        if (!startTime) startTime = timestamp;

        const progress = Math.min((timestamp - startTime) / duration, 1);
        const currentCount = Math.floor(initialCount + progress * (finalCount - initialCount));

        element.textContent = currentCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

// Intersection Observer
const counterObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const target = entry.target;
            const count = parseInt(target.getAttribute('data-animate-to'));
            animateCounter(target, count, 2000); // Adjust duration as needed
            counterObserver.unobserve(target); // Stop observing once the element is animated
        }
    });
});

const counters = document.querySelectorAll('.animate-counter');
counters.forEach(counter => {
    counterObserver.observe(counter);
});